import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import Button from "../ui/Button";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate(); // Initialize navigation

  const closeMenu = () => setMenuOpen(false);

  // Helper function to handle navigation and close menu
  const handleNavigation = (path) => {
    navigate(path);
    closeMenu();
  };

  return (
    <header className="w-full relative z-50">
      <div className="w-full max-w-[1620px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 lg:py-6">
          {/* Menu Trigger (Desktop Left) */}
          <button
            className="hidden xl:block p-2 flex-none xl:w-[190px]"
            aria-label="Open menu"
            onClick={() => setMenuOpen(true)}
          >
            <img src="/assets/menuIcon.png" alt="Menu Icon" />
          </button>

          {/* Logo - Centered (Clickable to Home) */}
          <div className="flex-1 flex justify-start xl:justify-center">
            <button onClick={() => navigate("/")} className="cursor-pointer">
              <img
                src="/assets/headerLogo.png"
                alt="Utpann Organic Agriculture Solutions"
                className="w-[140px] h-[56px] md:w-[165px] md:h-[66px] lg:w-[190px] lg:h-[76px]"
              />
            </button>
          </div>

          {/* Contact Us Button (Desktop) */}
          <div className="hidden xl:block">
            <Button
              text="Contact Us"
              onClick={() => navigate("/contact-us")} // Navigate to contact
              text_font_size="text-sm"
              text_font_family="Parkinsans"
              text_font_weight="font-semibold"
              text_line_height="leading-normal"
              text_text_align="center"
              // text_color="#343163"
              border_border="1px solid #343163"
              border_border_radius="rounded-xl"
              layout_width="auto"
              padding="t=12px,r=32px,b=12px,l=32px"
              className="mt-6 w-full justify-center hover:bg-secondary-text hover:text-white text-[#343163] transition-colors duration-300"
            />
          </div>

          {/* Menu Trigger (Mobile Right) */}
          <button
            className="block xl:hidden p-2 flex-none"
            aria-label="Open menu"
            onClick={() => setMenuOpen(true)}
          >
            <img src="/assets/menuIcon.png" alt="Menu Icon" />
          </button>
        </div>
      </div>

      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-10 transition-opacity duration-300 ${
          menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={closeMenu}
      ></div>

      {/* Side Menu Drawer */}
      <nav
        className={`fixed top-0 right-0 h-full w-[300px] bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 p-6 ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-end mb-8">
          <button className="p-2 text-gray-800" onClick={closeMenu}>
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="flex flex-col items-start space-y-6">
          <img
            src="/assets/headerLogo.png"
            alt="Logo"
            className="w-[140px] h-[56px] mb-4"
          />

          {/* Nav Links using handleNavigation */}
          {[
            { name: "About", path: "/about" },
            { name: "Products", path: "/products" },
            { name: "Blog", path: "/blog" },
          ].map((link) => (
            <button
              key={link.name}
              onClick={() => handleNavigation(link.path)}
              className="text-gray-700 hover:text-primary text-[20px] font-medium"
            >
              {link.name}
            </button>
          ))}

          <Button
            text="Contact Us"
            onClick={() => handleNavigation("/contact-us")}
            text_font_size="text-sm"
            text_font_family="Parkinsans"
            text_font_weight="font-semibold"
            text_line_height="leading-normal"
            text_text_align="center"
            // text_color="#343163"
            border_border="1px solid #343163"
            border_border_radius="rounded-xl"
            layout_width="auto"
            padding="t=12px,r=32px,b=12px,l=32px"
            className="mt-6 w-full justify-center hover:bg-secondary-text hover:text-white text-[#343163] transition-colors duration-300"
          />
        </div>
      </nav>
    </header>
  );
};

export default Header;
